export default {
    bindings: {
        invoice: '=',
        useCurrent: '@',
    },
    template: '<span>{{$ctrl.invoice.applicant}}</span>',
    controller() {
        this.$onChanges = function onChange() {
            const { invoice } = this
            if (!invoice) {
                return
            }
            if (this.useCurrent) {
                const userInfo = JSON.parse(localStorage.getItem('user_info'))
                this.invoice.applicant = invoice.applicant || userInfo.user.realName
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/invoiceApplicantComponent.js